import {computed, observable} from 'mobx';

export type Timestamp = number;
export type DesignVersionId = string;

export enum DesignVersionFilterType
{
    SHEET = 'sheet',
    PAGE = 'page',

    COMPONENTS = 'component',
    POSITIONS = 'position',
    NOTES = 'notes',
    EVENT_BINDINGS = 'eventBinding',
    PROP_BINDINGS = 'propBinding',
    NAMED_RANGES = 'namedRange',
    CELLS = 'cell',

    ADDED = 'added',
    REMOVED = 'removed',
    CHANGED = 'changed',
}

export class DesignVersion
{
    constructor(
        public readonly id:DesignVersionId,
        public readonly name:string,
        public readonly description:string,
        public readonly timestamp:Timestamp,
        public readonly author:string,
        public readonly isCurrent:boolean,
        public readonly isPublished:boolean,
    )
    {
    }
}

export class DesignVersionsState
{
    @observable
    public versions:DesignVersion[] = [];

    @observable
    public currentVersion:DesignVersion = null;

    @observable
    public openedVersionId:DesignVersionId = '';

    @observable
    public menuVersionId:DesignVersionId = null;

    @observable
    public restoreVersionId:DesignVersionId = null;

    @observable
    public isRestoring:boolean = false;

    @observable
    public selectedVersions:DesignVersionId[] = [];

    @observable
    public showPanel:boolean = false;

    @observable
    public showDiff:boolean = false;

    @observable
    public showDetails:boolean = false;

    @observable
    public filters = {
        [DesignVersionFilterType.PAGE]: true,
        [DesignVersionFilterType.SHEET]: true,

        [DesignVersionFilterType.COMPONENTS]: true,
        [DesignVersionFilterType.POSITIONS]: true,
        [DesignVersionFilterType.NOTES]: true,
        [DesignVersionFilterType.EVENT_BINDINGS]: true,
        [DesignVersionFilterType.PROP_BINDINGS]: true,
        [DesignVersionFilterType.NAMED_RANGES]: true,
        [DesignVersionFilterType.CELLS]: true,

        [DesignVersionFilterType.ADDED]: true,
        [DesignVersionFilterType.REMOVED]: true,
        [DesignVersionFilterType.CHANGED]: true,
    };

    @computed
    public get restoreVersion():DesignVersion
    {
        return this.versions.find((version:DesignVersion) => version.id === this.restoreVersionId);
    }
}
